// extracted by mini-css-extract-plugin
export default {"voicesSectionContainer":"VoicesSection_voicesSectionContainer__QqztG"};